import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PartialTuitionAmountDto } from '../../models/tuitionCalculation/partialTuitionAmountDto';

@Component({
  selector: 'app-partial-tuition-amount',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './partial-tuition-amount.component.html',
  styleUrl: './partial-tuition-amount.component.css'
})
export class PartialTuitionAmountComponent {


  @Input() partialTuitionAmount!: PartialTuitionAmountDto;

  @Input() isGeneral: boolean = false;

  @Input() isStudent: boolean = false;

  @Input() isCompany: boolean = false;

  constructor() {

  }

  get currentDto(): any {
    if (this.isGeneral) {
      return this.partialTuitionAmount;
    }
    if (this.isStudent) {
      return this.partialTuitionAmount.partialTuitionAmountStudentDto;
    }
    if (this.isCompany) {
      return this.partialTuitionAmount.partialTuitionAmountCompanyDto;
    }
    return {};
  }

  get suffix(): string {
    if (this.isGeneral) { 
      return '';
     }
    if (this.isStudent) { 
      return 'Student'
     };
    if (this.isCompany) { 
      return 'Company'
     };
    return '';
  }

}
